import GalleryVideo from "../blocks/gallery-video";
import OnlySmallsNavCards from "../blocks/only-smalls-nav-cards";
import NavCards from "../blocks/nav-cards";

const templateServices = {
  init() {
    new GalleryVideo(".gallery-video");
    new OnlySmallsNavCards(".nav-card-block--only-smalls");
    new NavCards(".nav-card-block");
  },
};
export default templateServices;
